export class Taak {

  static deserialize(dto: TaakDto): Taak {
    return new Taak(
      dto.id,
      dto.label,
      dto.frequentie,
      dto.icoon,
      dto.type,
    );
  }

  constructor(
    private id: string,
    private label: string,
    private frequentie: string,
    private icoon: string,
    private type: TaakType
  ) {
  }

  getId(): string {
    return this.id;
  }

  hasId(id: string): boolean {
    return this.id === id;
  }

  getLabel(): string {
    return this.label;
  }

  getFrequentie(): string {
    return this.frequentie;
  }

  getIcoon(): string {
    return this.icoon;
  }

  getIcoonPath(iconRoot: string): string {
    return `${iconRoot}/${this.icoon}`;
  }

  getType(): string {
    return this.type;
  }

  hasType(type: TaakType): boolean {
    return this.type === type;
  }
}

export type TaakType = 'STANDAARD' | 'EXTRA';
export const taakTypes: Array<TaakType> = ['STANDAARD', 'EXTRA'];

export interface TaakDto {
  id: string;
  label: string;
  frequentie: string;
  icoon: string;
  type: TaakType;
}
